import React, { useState } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { Modal } from 'react-responsive-modal';
import modalStyles from 'react-responsive-modal/styles.css';

import { Container, Row, Col, Button } from 'reactstrap';
import ThumborImage from 'components/ThumborImage';

import s from './FullscreenGallery.css';

const scrollTo = anchor => {
  const el = document.getElementById(anchor);
  if (el) {
    el.scrollIntoView();
  }
};

const FullscreenGallery = withStyles(s, modalStyles)(
  ({
    images,
    show = false,
    setShow = () => null,
    title = 'Всі фото',
    active = null,
  }) => {
    const allImages = active
      ? [
          { ...active, anchor: 'active' },
          ...images.filter(item => item.anchor !== active.anchor),
        ]
      : images;

    if (!show) {
      return null;
    }

    return (
      <Modal
        classNames={{
          modal: s.root,
          closeIcon: s.closeIcon,
          closeButton: s.close,
          overlay: s.overlay,
        }}
        open={show}
        onClose={() => setShow(false)}
      >
        <Container fluid>
          <Row>
            <Col>
              <h3 className={s.heading}>{title}</h3>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col lg={2} xl={2} className="d-none d-xl-block">
              <div className={s.images}>
                {images.map(({ thumbnail, anchor, alt }) => (
                  <div key={anchor}>
                    <Button color="link" onClick={() => scrollTo(anchor)}>
                      <ThumborImage
                        src={thumbnail}
                        width={100}
                        className={s.thumbnail}
                        alt={`${alt} (мініатюра)`}
                        lazyProps={{
                          overflow: true,
                          height: 75,
                          offset: 75,
                          throttle: true,
                        }}
                      />
                    </Button>
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={12} xl={8}>
              <div className={s.images}>
                {allImages.map(({ original, anchor, alt, type }) => (
                  <div id={anchor}>
                    <div className={s.alt}>
                      {type === 'catalog' && <b>фото з каталогу: </b>}
                      {alt}
                    </div>
                    <ThumborImage
                      key={anchor}
                      src={original}
                      width={800}
                      className={s.image}
                      alt={alt}
                      lazyProps={{
                        height: 600,
                        offset: 600,
                        overflow: true,
                        throttle: true,
                      }}
                    />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
    );
  },
);

export default FullscreenGallery;

export const useFullscreenGallery = (initialState = false) => {
  const [show, setShow] = useState(initialState);
  const [activeAnchor, setActiveAnchor] = useState(null);

  return [
    props => (
      <FullscreenGallery
        {...props}
        show={show}
        setShow={setShow}
        active={activeAnchor}
      />
    ),
    { show, setShow, setActiveAnchor },
  ];
};
